import Vue from 'vue'
import Vuex from 'vuex'
import authService from '@/services/authService'
import listItemService from '@/services/listItemService'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    access_token: '',
    renewal_token: '',
    expire_in: 0,
    push_token: '',
    ip:'',
    offset: (new Date()).getTimezoneOffset(),
    functionalities: [],
    showHeader: true,
    showFooter: true,
    environment: 'db000000',
    appBarCaption: 'AskMe',
    isHello: true,
    profile: {},
    preLoadVehicles: [],
    preLoadUsers: [],
    vehicleFilters: {},
    userFilters: {},
    listItems: {},
    requestsTab: 'tab-1',
    dossiersTab: 'tab-1',
    profileTab: 'tab-1',
    settingsTab: 'tab-1',
    customerTab: 'tab-1',
    vehicleTab: 'tab-1'
  },
  getters: {
    isViewableHeader: (state) => state.showHeader,
    isViewableFooter: (state) => state.showFooter,    
    isHello: (state) => state.isHello,
    userEnvironment: (state) => state.environment,
    profile: (state) => state.profile,
    appBarCaption: (state) => state.appBarCaption,
    preLoadVehicles: (state) => state.preLoadVehicles,
    preLoadUsers: (state) => state.preLoadUsers,
    vehicleFilters: (state) => state.vehicleFilters,
    userFilters: (state) => state.userFilters,
    listItems: (state) => state.listItems,
    requestsTab: (state) => state.requestsTab,
    dossiersTab: (state) => state.dossiersTab,
    profileTab: (state) => state.profileTab,
    settingsTab: (state) => state.settingsTab,
    customerTab: (state) => state.customerTab,
    vehicleTab: (state) => state.vehicleTab
  },
  mutations: {
    setViewableHeader: (state, value) => {state.showHeader = value},
    setViewableFooter: (state, value) => {state.showFooter = value},
    setAppBarCaption: (state, value) => {state.appBarCaption = value},
    setHello: (state, value) => {state.isHello = value},
    setProfile: (state, profile) => {state.profile = profile},
    setFunctionalities: (state, functionalities) => {state.functionalities = functionalities},    
    setAccessToken: (state, token) => {state.access_token = token},
    setPushToken: (state, token) => {state.access_token = token},
    setRenewalToken: (state, token) => {state.renewal_token = token},
    setExpirationTime: (state, time) => {state.expire_in = time},
    setIp: (state, ip) => {state.ip = ip},
    setPreLoadVehicles: (state, vehicles) => {state.preLoadVehicles = vehicles},
    setPreLoadUsers: (state, users) => {state.preLoadUsers = users},
    setVehicleFilters: (state, filters) => {
      state.vehicleFilters = filters
      localStorage.setItem('askme.filters.vehicles', JSON.stringify(filters))
    },
    setUserFilters: (state, filters) => {
      state.userFilters = filters
      localStorage.setItem('askme.filters.users', JSON.stringify(filters))
    },
    setRequestsTab: (state, tab) => {state.requestsTab = tab},
    setDossiersTab: (state, tab) => {state.dossiersTab = tab},
    setProfileTab: (state, tab) => {state.profileTab = tab},
    setSettingsTab: (state, tab) => {state.settingsTab = tab},
    setCustomerTab: (state, tab) => {state.customerTab = tab},
    setVehicleTab: (state, tab) => {state.vehicleTab = tab}
  },
  actions: {
    logout(context) {
        context.commit('setAccessToken', '');
        context.commit('setRenewalToken', '');
        context.commit('setExpirationTime', 0);
        context.commit('setProfile', {});        
    },
    login(context, loginData) {
      return new Promise((resolve, reject) => {
        if (loginData.user === '') return reject()
        authService.login(loginData)
          .then(data => {
                localStorage.setItem('user-token', data.access_token)
                authService.setAuthToken(data.access_token)
                context.commit('setAccessToken', data.access_token);
                context.commit('setRenewalToken', data.renewal_token);
                context.commit('setExpirationTime', data.expire_in);
                let info = {
                  name: loginData.user,
                };
                context.commit('setProfile', info);
                resolve();
          })
          .catch(error => {reject(error)});
      });
    },
    renewalToken(context) {
      return new Promise((resolve, reject) => {
        authService.renewalToken(context.state.renewal_token)
          .then(data => {
                context.commit('setAccessToken', data.access_token);
                context.commit('setRenewalToken', data.renewal_token);
                context.commit('setExpirationTime', data.expire_in);
                authService.setAuthToken(data.access_token)
                resolve(data);
          })
          .catch(error => {reject(error)});
      });
    },
    initFiltersVehicle(context) {
      let filters = localStorage.getItem('askme.filters.vehicles')
      if (filters !== null) context.state.vehicleFilters = JSON.parse(localStorage.getItem('askme.filters.vehicles'))
    },
    initFiltersUser(context) {
      let filters = localStorage.getItem('askme.filters.users')
      if (filters !== null) context.state.userFilters = JSON.parse(localStorage.getItem('askme.filters.users'))
    },
    getListItems(context, name) {
      return new Promise((resolve, reject) => {
        if (context.state.listItems.hasOwnProperty(name)) resolve(context.state.listItems[name])
        else {
          listItemService.getListItems(name)
              .then(data => {
                    context.state.listItems[name] = data
                    resolve(context.state.listItems[name])
              })
              .catch(error => {reject(error)});
          }
      })
    }
  },
  modules: {
  }
})
